import { useCallback, useMemo } from 'react'
import clsx from 'clsx'
import { OrderCancelReason } from 'lib/graphql/storeadmin'
import { reasonSelectSet } from 'components/bookings/modals'
import { Card, Col, Comment, Text, Timeline } from 'components/common'
import { datetime, time as TimeFormat } from 'lib/str-formatter'
import { BookingDate } from '.'

// TODO: Phase 1 では未使用
// const Editor = ({ onChange, onSubmit, submitting, value }) => (
//   <>
//     <Form.Item>
//       <TextArea rows={4} onChange={onChange} value={value} />
//     </Form.Item>
//     <Form.Item>
//       <Button
//         htmlType="submit"
//         loading={submitting}
//         onClick={onSubmit}
//         type="primary"
//       >
//         コメントを追加する
//       </Button>
//     </Form.Item>
//   </>
// )

interface BookingsEditReasonProps {
  bookingDate?: BookingDate
  cancelReason?: OrderCancelReason
  createdAt: string
  reasonForDisapproval?: string
  /* eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any */
  modifyReasons: any
  updatedAt: string
}

export const BookingsEditReason = ({
  bookingDate,
  cancelReason,
  createdAt,
  modifyReasons,
  reasonForDisapproval,
  updatedAt,
}: BookingsEditReasonProps): JSX.Element => {
  const reasonOfCancel = reasonSelectSet(cancelReason)
  const cancelOrReasonForDisapproval =
    cancelReason !== null || reasonForDisapproval !== null
  /* eslint-disable-next-line */
  const modifyReasonsData = [...modifyReasons?.edges].reverse()

  const modifier =
    modifyReasonsData[modifyReasonsData.length - 1]?.modify?.modifier

  const memoModifyReasons = useMemo(() => {
    return modifyReasonsData?.map(({ modify }) => {
      const { reason, modifiedAt, modifier } = modify

      let updatedReason: string
      if (reason === 'create by administrator') {
        updatedReason = '管理者によって作成されました'
      } else if (reason === 'cancel by administrator') {
        updatedReason = '管理者によってキャンセルされました'
      } else {
        updatedReason = reason
      }

      return (
        <Timeline.Item key={`${modifier?.id} ${modifiedAt}`}>
          <Col span={12}>
            <Card
              bodyStyle={{
                padding: '0',
              }}
              shadow
            >
              <Comment
                style={{
                  paddingLeft: '16',
                  paddingRight: '16',
                }}
                author={`${modifier?.lastName} ${modifier?.firstName}`}
                // TODO: Comment out to show user avatar
                // avatar={
                //   <Avatar
                //     src={modifier?.avatarUrl}
                //     alt={modifier?.lastName}
                //   />
                // }
                content={updatedReason}
                datetime={datetime(modifiedAt)}
              />
            </Card>
          </Col>
        </Timeline.Item>
      )
    })
  }, [modifyReasonsData])

  const checkInOutTimeStatus = useCallback(
    (time: string, type: string) => {
      return (
        <Timeline.Item key={`${time}${type}`}>
          <Col span={12}>
            <Card
              bodyStyle={{
                padding: '0',
              }}
              shadow
            >
              <Comment
                style={{
                  paddingLeft: '16',
                  paddingRight: '16',
                }}
                author={
                  typeof modifier !== 'undefined'
                    ? `${modifier?.lastName} ${modifier?.firstName}`
                    : 'チェックインステータス'
                }
                content={
                  type === 'チェックイン'
                    ? 'チェックインしました。'
                    : 'チェックアウトしました。'
                }
                datetime={TimeFormat(time)}
              />
            </Card>
          </Col>
        </Timeline.Item>
      )
    },
    [modifier]
  )

  // TODO: Phase 1 では未使用
  // const [comments, setComments] = useState([])
  // const [submitting, setSubmitting] = useBoolean(false)
  // const [commentValue, setCommentValue] = useState('')
  // const handleSubmit = () => {
  //   if (!commentValue) {
  //     return
  //   }
  //   setSubmitting.setTrue
  //   setTimeout(() => {
  //     setSubmitting.setFalse
  //     setCommentValue('')
  //     setComments([
  //       ...comments,
  //       {
  //         author: '阿部 幹',
  //         avatar: 'https://joeschmoe.io/api/v1/random',
  //         content: <p>{commentValue}</p>,
  //         datetime: moment().fromNow(),
  //       },
  //     ])
  //   })
  // }
  //
  // const handleChange = (e) => {
  //   setCommentValue(e.target.value)
  // }

  return (
    <>
      <Timeline>
        {/* TODO: Phase 1 では未使用 */}
        {/*<Timeline.Item*/}
        {/*  dot={*/}
        {/*    <Avatar src="https://joeschmoe.io/api/v1/random" alt="阿部 幹DF" />*/}
        {/*  }*/}
        {/*>*/}
        {/*  <Card>*/}
        {/*    <Comment*/}
        {/*      content={*/}
        {/*        <Editor*/}
        {/*          onChange={handleChange}*/}
        {/*          onSubmit={handleSubmit}*/}
        {/*          submitting={submitting}*/}
        {/*          value={commentValue}*/}
        {/*        />*/}
        {/*      }*/}
        {/*    />*/}
        {/*  </Card>*/}
        {/*</Timeline.Item>*/}
        {cancelOrReasonForDisapproval && (
          <Timeline.Item
            key={
              cancelReason
                ? `${cancelReason} ${updatedAt}`
                : `${reasonForDisapproval} ${updatedAt}`
            }
          >
            <Col span={12}>
              <Card
                bodyStyle={{
                  padding: '0',
                }}
                shadow
              >
                <Comment
                  style={{
                    paddingLeft: '16',
                    paddingRight: '16',
                  }}
                  author={
                    cancelReason
                      ? `予約をキャンセルされた理由`
                      : '予約を不承認にされた理由'
                  }
                  content={cancelReason ? reasonOfCancel : reasonForDisapproval}
                  datetime={datetime(updatedAt)}
                />
              </Card>
            </Col>
          </Timeline.Item>
        )}
        {bookingDate?.checkedOutAt !== null &&
          checkInOutTimeStatus(
            bookingDate?.checkedOutAt?.toString(),
            'チェックアウト'
          )}
        {bookingDate?.checkedInAt !== null &&
          checkInOutTimeStatus(
            bookingDate?.checkedInAt?.toString(),
            'チェックイン'
          )}
        {memoModifyReasons}

        <Timeline.Item>
          <span>予約が作成されました</span>
          <span className={clsx('pl-2')}>
            <Text mute>{datetime(createdAt)}</Text>
          </span>
        </Timeline.Item>
      </Timeline>
    </>
  )
}
